import React from 'react';
import styled from 'styled-components';

export default function B2BBox({ img, title, text, action }) {
    return (
        <Wrapper>
            <ImgBtn className="aniamte pointer" onClick={action ? () => action() : null}>
                <img className="radius8" src={img} alt="b2b"></img>
            </ImgBtn>
            <h3 className="font20 extraBold">{title}</h3>
            <Text>
                <p className="font18">{text}</p>
            </Text>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
    margin-top: 0px;
    transition: all 0.3s ease;

    img {
        width: 100%;
        height: auto;
        margin: 0 0 10px 0;
        border-radius: 8px;
        transition: all 0.3s ease;
    }

    h3 {
        padding-bottom: 10px;
    }

    /* Hover effect for desktop */
    &:hover {
        transform: translateY(-8px) scale(1.02);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    }

    /* Disable hover on touch devices / small screens */
    @media (hover: none) and (pointer: coarse) {
        &:hover {
            transform: none;
            box-shadow: none;
        }
    }
`;
const ImgBtn = styled.button`
    background-color: transparent;
    border: 0px;
    outline: none;
    padding: 0px;
    margin: 0px;
    :hover > img {
        opacity: 0.5;
    }
`;

const Text = styled.div`
    padding: 15px 0 50px 0;
    line-height: 1.7rem;
    @media (max-width: 970px) {
        padding: 15px 0 50px 0;
        text-align: center;
        max-width: 100%;
    }
`;
